import React, { createContext, useState, useContext, useEffect } from 'react';
import { setCurrentUser, checkAdmin, resetOnlogout } from './utils';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [gUserData, setUser] = useState(null);
  const [gUserRole, setUserRole] = useState(0); // 0 - attendee, 1 - admin
  const [isSessionExpire, setSessionExpire] = useState(true);

  useEffect(() => {
    const storedUser = sessionStorage.getItem("currentUser");
    const expiration = sessionStorage.getItem("sessionExpiry");

    if (storedUser && expiration) {
      const now = new Date().getTime();

      if (now > parseInt(expiration, 10)) {
        sessionStorage.removeItem("currentUser");
        sessionStorage.removeItem("sessionExpiry");
        setUser(null);
        setUserRole(0);
        setSessionExpire(true);
        resetOnlogout();
      } else {
        setUser(JSON.parse(storedUser));
        setUserRole(JSON.parse(sessionStorage.getItem("userRole")) || 0);
        setCurrentUser(JSON.parse(storedUser));
        checkAdmin(gUserRole);
        setSessionExpire(false);
      }
    }/* else{
      setSessionExpire(true);
      resetOnlogout();
    } */
  }, [gUserRole]);

  useEffect(() => {
    if (gUserData) {
      const expiryTime = new Date().getTime() + 60 * 60 * 1000; // 1 hour from now
      //const expiryTime = new Date().getTime() + 1 * 15 * 1000; // 15 second
      sessionStorage.setItem("currentUser", JSON.stringify(gUserData));
      sessionStorage.setItem("userRole", JSON.stringify(gUserRole));
      sessionStorage.setItem("sessionExpiry", expiryTime);
    }
  }, [gUserData, gUserRole]);

  const setUserData = (userData) => {
    setUser(userData);
    const sessionData = JSON.parse(sessionStorage.getItem("currentUser"));
    const newData = {...sessionData, ...userData};
    sessionStorage.setItem("currentUser", JSON.stringify(newData));
  };

  const onLoginContext = (userData, userRole) => {
    setSessionExpire(false);
    setUser(userData);
    setUserRole(userRole === 1 ? true : false);
  };

  const onLogoutContext = () => {
    sessionStorage.removeItem("currentUser");
    sessionStorage.removeItem("userRole");
    sessionStorage.removeItem("sessionExpiry");
    setUser(null);
    setUserRole(0);
  };

  return (
    <UserContext.Provider value={{ setUserData, gUserData, gUserRole, isSessionExpire, onLoginContext, onLogoutContext }}>
      {children}
    </UserContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(UserContext);
};
